import React from "react";

const NotFound = () => {
  return (
    <div className="text-center flex items-center justify-center">
      <div>
        <h2 className=" text-2xl text-sky-500 font-semibold  py-10">
          404 Not found page
        </h2>
        <img
          src="https://i.ibb.co/nnrGSMT/error-404-page-not-found-landing-page-concept-for-mobile-and-pc-free-vector.jpg"
          alt=""
        />
      </div>
    </div>
  );
};

export default NotFound;
